import wretch from 'wretch'
import { InitialConfig, Thread } from '@loctypes'

type UploadFileResponse = { fileUrl: string }

export default class ChatAPI {
  static async uploadFile(
    formObject: FormData,
    progressCallback: (e: ProgressEvent) => void
  ): Promise<UploadFileResponse> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()

      xhr.upload.onprogress = progressCallback
      xhr.onloadend = function () {
        xhr.status === 200 ? resolve(JSON.parse(xhr.responseText)) : reject(this.status)
      }

      xhr.open('POST', `${LINKER_SERVICE_URL}/upload`)
      xhr.send(formObject)
    })
  }

  static fetchThreads(clientKey: InitialConfig['clientKey'], algorithm = 'public'): Promise<Thread[]> {
    return wretch(`${LINKER_SERVICE_URL}/threads/${clientKey}`).query({ algorithm }).get().json()
  }
}
